import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  withXhr,
} from '@angular/common/http';
import { authInterceptor, httpErrorInterceptor } from './interceptors';

export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(
      withXhr(),
      withInterceptors([authInterceptor, httpErrorInterceptor]),
    ),
  ]);
}
